<template>
<div ><div class="loader_label" >{{label}}</div><div class="loader"></div></div> 
</template>

<script>
export default {
  props: {
    label: {type: String, default: ''}
  }
}
</script>
<style>
.loader {
    border: 1px solid #CCCCCC; /* Light grey */
    border-top: 2px solid #354052; /* Blue */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 2s linear infinite;
    float: left;
}

.loader_label {
  float: left;
  padding: 5px;
  margin-right: 10px
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}  
</style>



// WEBPACK FOOTER //
// loader.vue?7ff012ad